"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.Render = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var engine_utils_1 = require("@verified/c11-engine.utils");
var context_1 = require("./context");
var wrapper = function (_a) {
    var Element = _a.Element, updateProps = _a.updateProps;
    return /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper(props) {
            var _this = _super.call(this, props) || this;
            _this.isAlreadyMounted = false;
            if (updateProps) {
                updateProps(_this.updateProps.bind(_this));
            }
            _this.state = {};
            return _this;
        }
        Wrapper.prototype.componentDidMount = function () {
            this.isAlreadyMounted = true;
            if (this.nextState) {
                this.setState(this.nextState);
            }
        };
        Wrapper.prototype.updateProps = function (props) {
            if (!this.isAlreadyMounted) {
                this.nextState = props;
            }
            else {
                this.setState(props);
            }
        };
        Wrapper.prototype.render = function () {
            return react_1.default.cloneElement(Element, __assign({}, this.state));
        };
        return Wrapper;
    }(react_1.default.Component));
};
var Render = /** @class */ (function () {
    function Render(config) {
        this.root = null;
        this.cache = {};
        this.debug = config.debug || false;
        this.element = config.element;
        this.container = config.container;
        this.moduleContext = config.moduleContext;
        this.updateProps = config.updateProps;
        this.context = {
            debug: this.debug,
            addProducer: this.addProducer.bind(this),
            subscribeViewInstance: this.subscribeViewInstance.bind(this),
            removeViewInstance: this.removeViewInstance.bind(this),
            setProducers: this.setProducers.bind(this),
            registerView: this.registerView.bind(this),
            getProducers: this.getProducers.bind(this),
            getRoot: this.getRoot.bind(this),
        };
    }
    Render.prototype.updateProducer = function (producerId, config) {
        Object.values(this.cache).forEach(function (x) {
            if (x.producers[producerId]) {
                x.producers[producerId] = config;
                Object.values(x.instances).forEach(function (y) {
                    y.replaceProducer(producerId, config);
                });
            }
        });
    };
    Render.prototype.updateView = function (sourceId, config) {
        if (!this.cache[sourceId]) {
            return;
        }
        this.cache[sourceId].config = config;
        Object.values(this.cache[sourceId].instances).forEach(function (x) {
            x.replaceView(config);
        });
    };
    Render.prototype.addProducer = function (config, context, opts) {
        var _this = this;
        if (config.sourceId &&
            (opts === null || opts === void 0 ? void 0 : opts.viewSourceId) &&
            this.cache[opts.viewSourceId] &&
            !this.cache[opts.viewSourceId].unsubscribeProducers[config.sourceId]) {
            var producerSourceId_1 = config.sourceId;
            var viewSourceId = opts.viewSourceId;
            var unsubscribeProducer = this.moduleContext.onSourceUpdate(producerSourceId_1, function (producerConfig) {
                return _this.updateProducer(producerSourceId_1, producerConfig);
            });
            this.cache[opts.viewSourceId].unsubscribeProducers[producerSourceId_1] =
                unsubscribeProducer;
        }
        var instance = this.moduleContext.addProducer(config, context);
        return instance;
    };
    Render.prototype.getProducers = function (sourceId) {
        var _a;
        var result = (_a = this.cache[sourceId]) === null || _a === void 0 ? void 0 : _a.producers;
        if (!result) {
            return;
        }
        return Object.values(result);
    };
    Render.prototype.registerView = function (sourceId, config) {
        var _this = this;
        if (this.cache[sourceId]) {
            return;
        }
        this.cache[sourceId] = {
            config: config,
            unsubscribeProducers: {},
            producers: {},
            instances: {},
            unsubscribeView: this.moduleContext.onSourceUpdate(sourceId, function (viewConfig) {
                _this.updateView(sourceId, viewConfig);
            }),
        };
    };
    Render.prototype.subscribeViewInstance = function (sourceId, viewId, viewApi) {
        this.cache[sourceId].instances[viewId] = viewApi;
    };
    Render.prototype.removeViewInstance = function (sourceId, viewId) {
        if (!this.cache[sourceId] || !this.cache[sourceId].instances[viewId]) {
            return;
        }
        delete this.cache[sourceId].instances[viewId];
    };
    Render.prototype.setProducers = function (sourceId, producers) {
        if (!this.cache[sourceId]) {
            throw new Error("cannot find source id");
        }
        for (var _i = 0, producers_1 = producers; _i < producers_1.length; _i++) {
            var x = producers_1[_i];
            var id = x.sourceId || (0, engine_utils_1.randomId)();
            this.cache[sourceId].producers[id] = x;
        }
    };
    Render.prototype.render = function (rootEl) {
        this.root = rootEl;
        var Wrapper = wrapper({
            Element: this.element,
            updateProps: this.updateProps,
        });
        react_dom_1.default.render(react_1.default.createElement(context_1.ViewProvider, { value: this.context },
            react_1.default.createElement(Wrapper, null)), rootEl);
    };
    Render.prototype.getRoot = function () {
        return this.root;
    };
    Render.prototype.unmount = function () {
        if (this.root) {
            react_dom_1.default.unmountComponentAtNode(this.root);
        }
        return this;
    };
    Render.prototype.mount = function () {
        var _this = this;
        var rootEl;
        if (typeof this.container === "string") {
            rootEl = document.querySelector(this.container);
        }
        else if (this.container instanceof Function) {
            rootEl = this.container();
            if (typeof rootEl === "string") {
                rootEl = document.querySelector(rootEl);
            }
        }
        else {
            rootEl = this.container;
        }
        if (rootEl instanceof Promise) {
            rootEl.then(function (x) {
                if (typeof x === "string") {
                    x = document.querySelector(x);
                }
                _this.render(x);
            });
        }
        else {
            this.render(rootEl);
        }
        return this;
    };
    return Render;
}());
exports.Render = Render;
var render = function (element, container, config) {
    if (config === void 0) { config = {}; }
    var instance;
    return {
        bootstrap: function () { },
        unmount: function () {
            if (instance) {
                instance.unmount();
                instance = undefined;
            }
        },
        mount: function (moduleContext) {
            instance = new Render({
                element: element,
                container: container,
                debug: config.debug || false,
                updateProps: config.updateProps,
                moduleContext: moduleContext,
            });
            instance.mount();
        },
    };
};
exports.render = render;
//# sourceMappingURL=data:application/json;base64,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